import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";

export default function StepChannelName({ value, error, onChange }) {
  return (
    <TextField
      label="Nome do canal"
      placeholder="Financeiro, Atendimento..."
      variant="outlined"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      fullWidth
      sx={{ mt: 2 }}
      error={Boolean(error)}
      helperText={error}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <AlternateEmailIcon sx={{ color: "#5e1bbb" }} />
          </InputAdornment>
        ),
      }}
    />
  );
}
